import { SalesOrderStatus } from '@/models/api/commerce-sales-order'
import { CartScopeEq } from '@/models/cart/group/scope'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'

/**
 * ブランドごとのLogilessマイページID
 * @see https://github.com/Everforth/growthpalette-front/issues/9129
 */
const logilessMyPageIdByBrand: { [brand: string]: string } = {
  rady: '6756',
  michellmacaron: '6751',
  cherimi: '6745',
  honeymew: '20245',
  solni: '16376',
}

/**
 * 領収書発行導線は注文日から3週間以内表示とする
 * @see https://github.com/Everforth/growthpalette-front/issues/9129#issuecomment-5187290746
 */
const receiptIssuablePeriodInDays = 21

export class ReceiptIssuanceUrlBuilder {
  constructor(
    private readonly cartScope: CartScopeEq,
    private readonly orderIdLabel: string
  ) {}

  build(): string | null {
    if (!this.cartScope.kind.isBrand) {
      return null
    }

    const logilessMyPageId = logilessMyPageIdByBrand[this.cartScope.value.toString()]

    if (!logilessMyPageId) {
      return null
    }

    return `https://app2.logiless.com/my_page/${logilessMyPageId}/sign_in?code=${encodeURIComponent(this.orderIdLabel)}`
  }
}

export const receiptIssuanceLinkShouldShow = (deps: {
  url: string | null,
  salesOrderStatus: SalesOrderStatus,
  orderCreatedAt: Date,
  now: Date,
}): boolean => {
  const elapsedDays = differenceInCalendarDays(deps.now, deps.orderCreatedAt)

  return deps.url !== null &&
    deps.salesOrderStatus === 'shipment-delivering' &&
    elapsedDays <= receiptIssuablePeriodInDays
}
